import { C } from "../../theme/tokens";

/* Folded-page-corner triangle — Education's own card silhouette,
   distinct from Scanner's viewfinder cut and Copytrading's ticket
   notches. Parent needs position: relative. */
export function FoldedCorner() {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "0 36px 36px 0",
        borderColor: `transparent ${C.eduBright} transparent transparent`,
        opacity: 0.85,
        pointerEvents: "none",
      }}
    />
  );
}
